module.exports = __webpack_public_path__ + "img/bears.ba3769e3.jpg";